module.exports = __webpack_public_path__ + "img/4-itol-settings.2b2f6029.png";